import { Box, styled } from '@mui/material';

import { COLORS } from '../../../configs/colors';

export const PageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: ${COLORS.BackgroundGrey};
`;

export const HeaderHeroWrapper = styled(Box)`
  background: linear-gradient(135deg, ${COLORS.NavyBlue} 0%, ${COLORS.NavyBlueDark} 100%);
  padding-bottom: 44px;
  position: relative;
`;

export const PageHeader = styled(Box)`
  display: flex;
  align-items: center;
  padding: 14px 16px 8px;
  color: ${COLORS.White};
  gap: 12px;
`;

export const HeaderContent = styled(Box)`
  flex: 1;
`;

export const HeaderRow = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ServiceIdTitle = styled(Box)`
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: -0.3px;
  color: ${COLORS.White};
`;

export const HeaderMeta = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 3px;
`;

export const HeaderLocation = styled(Box)`
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.7);
`;

export const PriorityBadge = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'bgColor',
})<{ bgColor?: string }>`
  font-weight: 700;
  font-size: 0.6rem;
  padding: 3px 10px;
  border-radius: 50px;
  background: ${({ bgColor }) => bgColor || 'rgba(255, 255, 255, 0.2)'};
  color: ${COLORS.White};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ClientLogo = styled(Box)`
  width: 30px;
  height: 30px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.6rem;
  color: ${COLORS.White};
  backdrop-filter: blur(10px);
  flex-shrink: 0;
`;

export const LoadingContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 40px;
`;

export const ErrorContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 40px;
`;

export const ErrorText = styled(Box)`
  font-size: 16px;
  color: ${COLORS.DarkRed};
  text-align: center;
`;

export const TabContainer = styled(Box)`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.BackgroundGrey};
`;

export const ContentContainer = styled(Box)`
  flex: 1;
  overflow-y: auto;
  padding-bottom: calc(88px + env(safe-area-inset-bottom));
  background-color: ${COLORS.BackgroundGrey};
`;

export const DetailSectionHeader = styled(Box)`
  font-weight: 700;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: ${COLORS.NavyBlue};
  margin-bottom: 10px;
  padding: 0 16px;
  margin-top: 16px;
`;

export const DetailCard = styled(Box)`
  background: ${COLORS.White};
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 14px 16px;
  margin: 0 16px 12px;
`;

export const DetailRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
  gap: 12px;

  &:last-child {
    border-bottom: none;
  }
`;

export const DetailLabel = styled(Box)`
  font-weight: 500;
  font-size: 0.72rem;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex-shrink: 0;
`;

export const DetailValue = styled(Box)`
  font-weight: 600;
  font-size: 0.85rem;
  color: ${COLORS.Black};
  text-align: right;
  word-break: break-word;
`;
